module.exports = __webpack_public_path__ + "static/media/SarahSwitek_15_ThatsAll_2.2c39e045.mp3";